import React from 'react';
import { IonRouterOutlet } from '@ionic/react';
import SideMenu from 'core/layout/side-menu/SideMenu';
import { useSelector } from 'react-redux';
import { RootState } from 'core/store';

declare global {
  interface Window {
    zE: any;
  }
}

type MenuLayoutProps = {};

const MenuLayout: React.FC<MenuLayoutProps> = ({ children }) => {
  const { isDesktopWidth } = useSelector((state: RootState) => state.platform);

  return !isDesktopWidth ? (
    <>
      <SideMenu />
      <IonRouterOutlet animated={false} id="main-content">
        {children}
      </IonRouterOutlet>
    </>
  ) : (
    <IonRouterOutlet animated={false} id="main-content">
      {children}
    </IonRouterOutlet>
  );
};

export default MenuLayout;
